"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.blockers_suite_sankey = void 0;
/* eslint @typescript-eslint/no-var-requires: "off" */
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const fa_1 = require("react-icons/fa");
const blockers_suite_sankey = (blocker_token_OSP, set_blocker_token_OSP, blocker_token_SSM, set_blocker_token_SSM) => {
    const block_OSP = react_1.default.createElement(react_bootstrap_1.Button, { size: 'sm', variant: blocker_token_OSP ? 'danger' : 'outline-danger', onClick: () => set_blocker_token_OSP(!blocker_token_OSP) },
        react_1.default.createElement(fa_1.FaBan, null));
    const block_SSM = react_1.default.createElement(react_bootstrap_1.Button, { size: 'sm', variant: blocker_token_SSM ? 'danger' : 'outline-danger', onClick: () => set_blocker_token_SSM(!blocker_token_SSM) },
        react_1.default.createElement(fa_1.FaBan, null));
    return {
        'block_osp': block_OSP,
        'block_ssm': block_SSM,
    };
};
exports.blockers_suite_sankey = blockers_suite_sankey;
